import { api } from '@api';
import type { CommentData, CommentsAdapter } from '@features/Comments/types';

export const courseCommentsAdapter: CommentsAdapter = {
  queryKey: 'course_comments',

  getComments: async (entityId: string): Promise<CommentData[]> => {
    const { data, error } = await api()
      .from('course_comments')
      .select(`
        id,
        content,
        parent_id,
        created_at,
        profile_id,
        profile:profile_id (
          id,
          username,
          profile_private (role)
        )
      `)
      .eq('lesson_id', entityId) // Using lesson_id here!
      .order('created_at', { ascending: false });

    if (error) throw new Error(error.message);
    return data as unknown as CommentData[];
  },

  createComment: async ({ entityId, content, profileId, parentId }) => {
    const { data, error } = await api()
      .from('course_comments')
      .insert({
        lesson_id: entityId, // Mapping to lesson_id
        content,
        profile_id: profileId,
        parent_id: parentId || null,
      })
      .select()
      .single();

    if (error) throw new Error(error.message);
    return data;
  },

  updateComment: async (commentId: string, content: string) => {
    const { error } = await api()
      .from('course_comments')
      .update({ content })
      .eq('id', commentId);

    if (error) throw new Error(error.message);
  },

  deleteComment: async (commentId: string) => {
    const { error } = await api()
      .from('course_comments')
      .delete()
      .eq('id', commentId);

    if (error) throw new Error(error.message);
  }
};
